var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list",
    { staticClass: "az-list-no-icon-spacing py-1", attrs: { dense: "" } },
    [
      _vm._l(_vm.folders, function(folder) {
        return [
          _vm.hasSubfolders(folder)
            ? _c(
                "v-menu",
                {
                  key: folder.id,
                  attrs: {
                    value: _vm.openFolderId === folder.id,
                    "offset-x": "",
                    right: "",
                    "nudge-right": "4",
                    "content-class": "aawz-drive-folder-picker-menu"
                  },
                  on: {
                    input: function($event) {
                      return _vm.onMenuInput(folder.id, $event)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-list-item",
                              _vm._b(
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onSelect(folder)
                                    },
                                    mouseenter: function($event) {
                                      return _vm.onActivatorEnter(folder.id)
                                    },
                                    mouseleave: _vm.scheduleClose
                                  }
                                },
                                "v-list-item",
                                attrs,
                                false
                              ),
                              [
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(folder.name))
                                ]),
                                _c("icon-svg", {
                                  attrs: {
                                    name: "mdi-chevron-right",
                                    size: "16",
                                    color: "#8E8E8E"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c(
                    "div",
                    {
                      on: {
                        mouseenter: _vm.notifyActive,
                        mouseleave: _vm.scheduleClose
                      }
                    },
                    [
                      _c("AawzDriveFolderPickerMenu", {
                        attrs: { folders: _vm.subfoldersOf(folder) },
                        on: { select: _vm.onSelect, active: _vm.notifyActive }
                      })
                    ],
                    1
                  )
                ]
              )
            : _c(
                "v-list-item",
                {
                  key: folder.id,
                  on: {
                    click: function($event) {
                      return _vm.onSelect(folder)
                    },
                    mouseenter: function($event) {
                      return _vm.$emit("active")
                    }
                  }
                },
                [_c("v-list-item-title", [_vm._v(_vm._s(folder.name))])],
                1
              )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }